import { render, staticRenderFns } from "./AgencyTransferInfo.vue?vue&type=template&id=1d763018&"
import script from "./AgencyTransferInfo.vue?vue&type=script&lang=js&"
export * from "./AgencyTransferInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports